module.exports = __webpack_public_path__ + "img/order-history-icon-9.png";